import { Area } from "Models/Areas/Area";
import { RoleType } from "../Users/RoleType";
import { LinkType } from "./LinkType";
import { MachineStatusType } from "./MachineStatusType";
import { TaskRecurrency } from "./TaskRecurrencies/TaskRecurrency";
import { TaskTemplateStep } from "./TaskTemplateStep";

export class TaskTemplate {
    public id?: number;
    public name: string;
    public pictureUrl?: string;
    public descriptionFileUrl?: string;
    public description: string;
    public type: string = "task";
    public deeplinkId?: number;
    public deeplinkTo: LinkType = LinkType.none;
    public role: RoleType = RoleType.basic;
    public positionIndex: number;
    public createdAt: Date;
    public lastUpdatedAt: Date;
    public taskTemplateTags: string;
    public weight: number;
    public videoUrl?: string;
    public videoThumbnailUrl?: string;
    public plannedTime?: number;
    public machineStatus: MachineStatusType = MachineStatusType.not_applicable;
    public taskRecurrencies: TaskRecurrency[] = [new TaskRecurrency()];
    public steps: TaskTemplateStep[] = [];
    public area: Area;
    public duplicatedFromTaskTemplateId?: number = undefined;
}


// WEBPACK FOOTER //
// ./src/Models/Tasks/TaskTemplate.ts